import React, { FC, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { QUERIES } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useFormik } from 'formik'
import * as Yup from 'yup'

type Props = {
    id: any
    close: () => void
}

const SalesApprovalModal: FC<Props> = ({ id, close }) => {
    console.log("id", id)
    const { query } = useQueryResponse()
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)

    const validationSchema = Yup.object().shape({
        quantity: Yup.number().required('Quantity is required'),
        price: Yup.number().required('Price is required'),
    })

    const formik = useFormik({
        initialValues: {
            quantity: id?.totalQuantity || '',
            price: id?.orderDetail?.[0]?.items?.[0]?.price || '',
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: handleApprove,
    })

    async function handleApprove() {
        try {
            setLoading(true)

            // Get auth token and user info from localStorage
            const authData = localStorage.getItem('kt-auth-react-v')
            const token = authData ? JSON.parse(authData).data.token : null
            const userId = authData ? JSON.parse(authData).data.userId : ''
            const userName = authData ? JSON.parse(authData).data.userName : ''
            const userRole = authData ? JSON.parse(authData).data.userRole?.name : ''
            // Make API call to approve order
            const response = await axios.post(
                `https://pfc-backend-api.asmglobal.co.in/v1/api/txn-sale-order/action?saleOrderId=${id?.id}&action=APPROVE&role=${userRole}&userId=${userId}`,
                {
                    quantity: formik.values.quantity,
                    price: formik.values.price,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            )

            console.log('Approval Response:', response.data)
            successToast('Order approved successfully!')
            queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
            close()
        } catch (error) {
            console.error('Error approving order:', error)
            if (error instanceof Error) {
                errorToast(error.message)
            } else {
                errorToast('Error approving order')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            }}
            onClick={close}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    maxWidth: '500px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 style={{ marginBottom: '20px', fontWeight: 600, fontSize: "17.55px" }}>Approve Order for {id?.saleOrderId}</h3>

                <form onSubmit={formik.handleSubmit} noValidate>
                    {/* Quantity Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Quantity (Kgs)</label>
                        <input
                            type='number'
                            {...formik.getFieldProps('quantity')}
                            placeholder='Enter quantity'
                            className='form-control form-control-solid'
                            style={{
                                border: formik.touched.quantity && formik.errors.quantity ? '1px solid #f8285a' : '1px solid #ddd',
                            }}
                            disabled={loading}
                        />
                        {formik.touched.quantity && formik.errors.quantity && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                    {formik.errors.quantity as string}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Price Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Price (INR/Kgs)</label>
                        <input
                            type='number'
                            {...formik.getFieldProps('price')}
                            placeholder='Enter price'
                            className='form-control form-control-solid'
                            style={{
                                border: formik.touched.price && formik.errors.price ? '1px solid #f8285a' : '1px solid #ddd',
                            }}
                            disabled={loading}
                        />
                        {formik.touched.price && formik.errors.price && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                    {formik.errors.price as string}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button
                            type='button'
                            onClick={close}
                            className='btn btn-light'
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type='submit'
                            className='btn btn-success'
                            disabled={loading}
                        >
                            {loading ? 'Approving...' : 'Approve'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default SalesApprovalModal